import { VFC, useContext, Dispatch } from 'react';
import { useHooks } from './useHooks';
import { SiteProcessCopyModal } from '../ProcessCopyModal';
import { OverallPeriodModal } from '../OverallPeriodModal';
import { EditButton } from '../../../atoms/Button';
import { useStyles } from './useStyles';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';

export type TProps = {
  constructId: number;
  reRenderSiteProcessData: () => void;
  setHasExpectedDays: Dispatch<boolean>;
  setHasSiteProcess: Dispatch<boolean>;
};

export const EmptySiteProcessView: VFC<TProps> = props => {
  const {
    constructId,
    reRenderSiteProcessData,
    setHasExpectedDays,
    setHasSiteProcess
  } = props;

  const {
    isOpenCopy,
    setIsOpenCopy,
    isOpenAdd,
    setIsOpenAdd,
    handleOnClickAdd,
    handleOnClickCopy,
    constructList
  } = useHooks({});

  const classes = useStyles();
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  return (
    <>
      {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
        <>
          <div className={classes.emptyProcessViewContainer}>
            <div className={`${classes.fontSize} ${classes.itemMargin}`}>
              まずは工程を作成しましょう。
            </div>
            <div>
              <EditButton
                onClick={handleOnClickAdd}
                className={`${classes.buttonWidth} ${classes.itemMargin}`}
              >
                工程表の新規作成
              </EditButton>
            </div>
            <div>
              <EditButton
                onClick={handleOnClickCopy}
                className={`${classes.buttonWidth} ${classes.itemMargin}`}
              >
                既存の工程表をコピー
              </EditButton>
            </div>

            {/* 工期設定モーダル */}
            <OverallPeriodModal
              isOpen={isOpenAdd}
              setIsOpen={setIsOpenAdd}
              constructId={constructId}
              setHasExpectedDays={setHasExpectedDays}
            />

            {/* 工程コピーモーダル */}
            <SiteProcessCopyModal
              isOpen={isOpenCopy}
              setIsOpen={setIsOpenCopy}
              constructList={constructList}
              afterSubmit={reRenderSiteProcessData}
              currentConstructId={constructId}
              setHasSiteProcess={setHasSiteProcess}
              setHasExpectedDays={setHasExpectedDays}
            />
          </div>
        </>
      )}
      {authInfo?.role === ROLE['OUTSIDE_PARTNER'] && (
        <>
          <div className={classes.emptyProcessViewContainer}>
            <div className={`${classes.fontSize} ${classes.itemMargin}`}>
              まだ工程が作成されていません。
            </div>
          </div>
        </>
      )}
    </>
  );
};
